import React from 'react';
import { Segment, Dimmer, Loader, Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history } from '../../helpers';
import Strings from '../../common/Strings';
import AccountInformation from './AccountInformation';
import '../Common.css';
import './Settings.css';
import { version } from '../../../package.json';
import { gitHash } from '../../gitHash.json';
import PlanAndBilling from './PlanAndBilling';
import { isCardExpiring } from '../../helpers/card';
import { failedPayment } from '../../helpers/payment';

class Settings extends React.Component {
  constructor(props) {
    super(props);

    this.accountInformationRef = React.createRef();
    this.state = {
      saveEnabled: false,
    };
  }

  onSaveChangedClicked = () => {
    this.accountInformationRef.current.getWrappedInstance().saveChanges();
  };

  renderGitHash = () => {
    if (process.env.REACT_APP_ENV === 'dev') {
      return (
        <div>
          <h4 id="settings-git-hash-title"> Git Hash </h4>
          <p id="settings-git-hash-text">{gitHash}</p>
        </div>
      );
    }
    return null;
  };

  renderTabs = () => {
    const { pathname } = window.location;
    const accountsTabClassName = pathname.includes('/settings/account')
      ? 'settings-tab-selected'
      : 'settings-tab';
    const planTabClassName = pathname.includes('/settings/billing')
      ? 'settings-tab-selected'
      : `settings-tab${
          this.props.paymentCardExpiring ||
          this.props.paymentHistoryFailedPayment
            ? ' common-warning-circle'
            : ''
        }`;

    return (
      <div className="settings-tabs">
        <Button
          className={accountsTabClassName}
          onClick={() => history.replace('/settings/account')}
        >
          {Strings.SETTINGS.accountInformation}
        </Button>
        <Button
          className={planTabClassName}
          onClick={() => history.replace('/settings/billing')}
        >
          {Strings.SETTINGS.planAndBilling}
        </Button>
      </div>
    );
  };

  render() {
    const { pathname } = window.location;
    let saveButton;
    let content;
    if (pathname.endsWith('/settings/account')) {
      saveButton = (
        <Button
          disabled={!this.state.saveEnabled}
          id="settings-save-button"
          className="common-green-button"
          onClick={this.onSaveChangedClicked}
        >
          {Strings.SETTINGS.save}
        </Button>
      );
      content = (
        <AccountInformation
          ref={this.accountInformationRef}
          formChanged={saveEnabled => {
            this.setState({ saveEnabled });
          }}
        />
      );
    } else {
      content = <PlanAndBilling />;
    }

    return (
      <Segment basic className="settings-root">
        <Dimmer active={this.props.loading} inverted>
          <Loader inverted />
        </Dimmer>
        <div className="settings">
          <div className="common-top-panel">
            <h1 id="settings-title" className="common-top-panel-title">
              {Strings.SETTINGS.settings}
            </h1>
            <div className="space" />
            {saveButton}
          </div>
          <div className="settings-content-wrapper">
            {this.renderTabs()}
            {content}
          </div>
        </div>
        <div className="common-side-panel">
          <div className="common-top-panel">
            <h1 id="settings-support-title" className="common-side-panel-title">
              {Strings.SETTINGS.support}
            </h1>
          </div>
          <div className="settings-support-content">
            <h1 id="settings-contact-us">{Strings.SETTINGS.contactUs}</h1>
            <p id="settings-contact-us-info">
              {Strings.SETTINGS.contactUsInfo}
              <a
                id="email-link-text"
                target="_top"
                rel="noopener noreferrer"
                href="mailto:support@iworkie.com"
              >
                {Strings.SETTINGS.contactUsEmail}
              </a>
            </p>
            <div>
              <h2 id="settings-version-title">
                {Strings.SETTINGS.versionNumber}
              </h2>
              <p id="settings-version-text">{version}</p>
            </div>
            {this.renderGitHash()}
          </div>
        </div>
      </Segment>
    );
  }
}

Settings.propTypes = {
  loading: PropTypes.bool,
  paymentCardExpiring: PropTypes.bool.isRequired,
  paymentHistoryFailedPayment: PropTypes.bool.isRequired,
};

Settings.defaultProps = {
  loading: false,
};

const mapStateToProps = state => ({
  loading: state.uiState.isUserLoading,
  paymentCardExpiring: isCardExpiring(
    state.paymentCards.card,
    state.upcomingInvoice.upcoming,
  ),
  paymentHistoryFailedPayment: failedPayment(state.paymentHistory.items),
});

export default connect(mapStateToProps)(Settings);



// WEBPACK FOOTER //
// ./src/components/settings/Settings.js